import * as React from "react";

import { UitkLink } from "uitk-react-link";
import { UitkIcon } from "uitk-react-icons";
import { UitkText } from "uitk-react-text";
import { UitkLayoutFlex } from "uitk-react-layout-flex";

import { TrackedLink } from "components/utility/analytics/TrackedLink";
import { iconMap } from "../CrossLOBLinks";

import { LinkProps } from "../typings";

const Link = (props: LinkProps) => {
  const { link } = props;
  const { icon, url, text, subtitle } = link;

  const iconName = iconMap[icon];
  if (!iconName) {
    return null;
  }

  return (
    <UitkLink>
      <TrackedLink href={url} rfrr={icon} moduleName="CrossLOBLinks">
        <UitkLayoutFlex space="one">
          <UitkIcon name={iconName} />

          <UitkLayoutFlex direction="column">
            <UitkText size={400}>{text}</UitkText>
            {Boolean(subtitle) && (
              <UitkText size={200} className="subtitle">
                {subtitle}
              </UitkText>
            )}
          </UitkLayoutFlex>
        </UitkLayoutFlex>
      </TrackedLink>
    </UitkLink>
  );
};

export default Link;
